import { get, post, req } from '@/plugins/axios'
import { useSite2Station } from '@/store'

/**
* 查询青蛙频道文章分页（前台）
* @param {Object} data
*/
export function getFrogArticleList (data: any) {
  return post('/customer/frog/article/page', data)
}

/**
* 根据传入type数组获取文章分页
* @param {Object} data
*/
export function getArticleListByType (data: any) {
  return post('/customer/frog/article/page', {
    ...data,
    stationCode: useSite2Station()
  })
}

/**
* 查询热门文章分页
* @param {Object} data
*/
export function getHotList (data: any) {
  return post('/customer/frog/article/hot/page', data)
}

/**
* 获取文章归档日期列表（按日期归档）
* @param {Object} data
*/
export function getArchiveDateList (data: any) {
  return post('/customer/frog/article/archive', data)
}

/**
* 查询归档文章列表分页
* @param {Object} data
*/
export function getArchiveArticleList (data: any) {
  return post('/customer/frog/article/archive/page', data)
}

/**
* 获取文章详情
* @param {Object} data
*/
export function getArticleDetail (data: any) {
  return get('/customer/frog/article/detail', data)
}

/**
* 创建青蛙文章
* @param {Object} data
*/
export function createArticle (data: any) {
  return post('/customer/frog/article/create', data)
}

/**
* 获取当前文章的上一篇/下一篇
* @param {Object} data
*/
export function getLastNext (data: any) {
  return post('/customer/frog/article/get/prepAndNext', data)
}

/**
* 文章累加阅读量
* @param {Object} data
*/
export function handleArticleCount (data: any) {
  return req('/customer/frog/article/count', data)
}
